import React, { useEffect, useState, useRef } from 'react';
import get from 'lodash/get';
import { isMobileOnly as isMobile, isTablet } from 'react-device-detect';
import { BQLink } from '../../atoms/bqlink';
import CardImage from '../../atoms/cardimage';
import AngleRight from '../../atoms/icons/angle-right';
import Slider from 'react-slick';
import { connect, useSelector } from 'react-redux';
import AdWithPlaceholder from '../../molecules/ad-with-placeholder';
import Icon from '@mdi/react';
import { mdiArrowRight } from '@mdi/js';
import './reaction-widget.m.css';
import { contentClick } from '../../../helpers/datalayer-utils';

const ReactionWidget = ({
  collection,
  widget,
  darkMode = false,
  lightMode = false,
  client = '',
  slideCheck,
}) => {
  const subscriber = useSelector((state) => get(state, ['userData', 'isSubscriber'], false));
  const [currentCard, setCurrentCard] = useState(0);
  const [cardCount, setCardCount] = useState(0);
  const [cardList, setCardList] = useState([]);
  const story = get(collection, 'items', [])
    .filter((c) => c.type === 'story')
    .slice(0, 8)
    .map(({ story }) => story)[0];
  const title = collection?.metadata?.['display-name'] || collection?.title;
  const slug = collection?.items[0]?.story?.slug || '#';
  const card = useRef(null);
  const firstBannerImg = collection?.items[0]?.story['hero-image-s3-key'];

  useEffect(() => {
    const getStoryData = async () => {
      try {
        let cards = [];
        const processStoryElements = (storyElements) => {
          return storyElements.reduce((filtered, element) => {
            if (element?.type === 'title') {
              filtered.title = element.text;
            } else if (element?.type === 'image') {
              filtered['hero-image-s3-key'] = element['image-s3-key'];
            } else if (element?.type === 'text' && element?.subtype === 'quote') {
              filtered.quote = element.text;
              filtered.attribution = element?.metadata?.attribution;
            }

            return filtered;
          }, {});
        };

        if (story?.cards) {
          cards = story.cards.map((item) => processStoryElements(item['story-elements']));
        } else if (story?.slug) {
          const response = await fetch(
            `https://www.ndtvprofit.com/api/v1/stories-by-slug?slug=${story?.slug}`,
          ).then((res) => res.json());

          cards =
            response?.story?.cards?.map((item) => processStoryElements(item['story-elements'])) ||
            [];
        }
        setCardList(cards);
      } catch (error) {
        console.error('Error fetching story data:', error);
      }
    };

    if (story?.slug) {
      getStoryData();
    }
  }, [story?.slug]);

  useEffect(() => {
    const slidesToShow = isMobile || isTablet ? 1 : 4;
    const totalSlides = Math.ceil(cardList.length / slidesToShow) - 1;
    setCardCount(totalSlides >= 0 ? totalSlides : 0);
  }, [cardList]);

  const SLIDER_SETTINGS = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    swipeToSlide: true,
    initialSlide: 0,
    afterChange: (current) => setCurrentCard(current),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          swipeToSlide: true,
          cssEase: 'ease-out',
          pauseOnHover: true,
          autoplay: !!client && slideCheck?.includes(client?.toLowerCase()) ? true : false,
          infinite: !!client && slideCheck?.includes(client?.toLowerCase()) ? true : false,
        }
      },
      {
        breakpoint: 600,
        settings: {
          dots: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          swipeToSlide: true,
          cssEase: 'ease-out',
          pauseOnHover: true,
          autoplay: !!client && slideCheck?.includes(client?.toLowerCase()) ? true : false,
          infinite: !!client && slideCheck?.includes(client?.toLowerCase()) ? true : false,
        },
      },
    ],
  };
  const userData = useSelector((state) => get(state, ['userData']));
  const pageType = useSelector((state) => get(state, ['qt', 'pageType']));

  return (
    <>
      <div
        styleName={`budget-reaction-slider ${widget ? 'widget-view' : ''} ${darkMode ? 'dark-mode-active' : ''} ${lightMode ? 'light-mode-active' : ''} ${!!client ? 'client-view' : ''}`}
      >
        <div styleName={`banner-wrap ${subscriber ? 'sub-banner' : ''}`}>
          <div onClick={() => contentClick(userData, collection?.items[0]?.story, pageType)}>
            <BQLink styleName="image-wrapper" href={slug}>
              <div styleName="cardwithoverlay">
                <img
                  src={`https://media.assettype.com/${firstBannerImg}`}
                  height="300px"
                  width="100%"
                  className="desktop-only"
                  styleName="firstBanner"
                />
                {(isMobile || isTablet) && widget && (
                  <img src={`https://media.assettype.com/${firstBannerImg}`} alt="" />
                )}
                {!widget && (
                  <div className="mobile-only">
                    <CardImage
                      story={collection?.items[0]?.story}
                      aspectRatio={[16, 9]}
                      imageType="image16x9"
                    />
                  </div>
                )}
                <div styleName="heading">
                  {((widget && (!isMobile && !isTablet)) || !widget) && (
                    <img src="/icons/quote_24px.svg" width="44px" height="32px" />
                  )}
                  <div>
                    {title.split(' ').map((t, i) => {
                      if (i === 0) {
                        return (
                          <div styleName="title" key={i}>
                            {t}
                          </div>
                        );
                      } else {
                        return <React.Fragment key={i}>{t}&nbsp;</React.Fragment>;
                      }
                    })}
                    {!client && (
                      <img src="/icons/ic_chevron_right_white_24px.svg" styleName="right-chevron" />
                    )}
                  </div>
                </div>
                <div styleName="story-overlay"></div>
              </div>
            </BQLink>
          </div>
          {!subscriber && !widget && (
            <div className="responsive-ad content-center" styleName="ads-wrap">
              <AdWithPlaceholder
                adtype="AdAboveReactionSlider"
                height="280px"
                width="336px"
                adUnit="Mid_300x250_2"
                sizes={[
                  [300, 250],
                  [336, 280],
                ]}
              />
            </div>
          )}
        </div>
        <div styleName="card-slider">
          {cardList?.length > 0 && (
            <Slider ref={card} {...SLIDER_SETTINGS}>
              {cardList?.map((list, index) => {
                const [title, ...attribution] = list.attribution?.split(',');
                const heroImageKey = list['hero-image-s3-key'];
                return (
                  <div
                    onClick={() => contentClick(userData, collection?.items[0]?.story, pageType)}
                    key={index}
                  >
                    <BQLink styleName="story-content" key={index} href={slug}>
                      <img
                        src={`https://media.assettype.com/${heroImageKey}`}
                        styleName="profile"
                        width="80px"
                        height="80px"
                      />
                      <div styleName="headline" dangerouslySetInnerHTML={{ __html: list.quote }} />
                      <div styleName="author-details">
                        <div>
                          <div styleName="author-name">{title}</div>
                          <div styleName="sub-headline">{attribution?.join(', ')}</div>
                        </div>
                        {!client && (
                          <div styleName="right-arrow">
                            <Icon path={mdiArrowRight} size="20px" color="#5b6e77" />
                          </div>
                        )}
                      </div>
                    </BQLink>
                  </div>
                );
              })}
            </Slider>
          )}
          {!isMobile && !isTablet && cardList?.length > 0 && (
            <>
              <div
                styleName={`prev ${currentCard <= 0 ? 'disabled' : ''}`}
                onClick={() => {
                  if (currentCard > 0) card?.current?.slickPrev();
                }}
              >
                <AngleRight
                  fontSize="12px"
                  color={currentCard === 0 ? 'fourth-color' : 'bg6-color'}
                />
              </div>

              <div
                styleName={`next ${currentCard >= cardCount ? 'disabled' : ''}`}
                onClick={() => {
                  if (currentCard < cardCount) card?.current?.slickNext();
                }}
              >
                <AngleRight
                  fontSize="12px"
                  color={currentCard >= cardCount ? 'fourth-color' : 'bg6-color'}
                />
              </div>
            </>
          )}
          <div styleName="slider-overlay"></div>
        </div>
      </div>
      {isMobile && !widget && (
        <div className="responsive-ad content-center adWithPad mobile-only" styleName="ads-wrap">
          <AdWithPlaceholder
            adtype="AdBelowReactionSlider"
            height="280px"
            width="336px"
            adUnit="Mid_300x250_3"
            sizes={[
              [300, 250],
              [336, 280],
            ]}
          />
        </div>
      )}
    </>
  );
};

const mapStatetoProps = (state) => ({
  slideCheck: get(state, ['qt', 'config', 'features', 'budget', 'budget_reaction_slider_list'], []),
});

export default connect(mapStatetoProps)(ReactionWidget);
